import React, { useEffect } from "react";
import "../style/AboutUs.css";
import { FaRocket, FaUsers, FaCar, FaLeaf } from "react-icons/fa";
import AOS from "aos";
import "aos/dist/aos.css";
import CEOImg from "../assets/Raman.jpg";
import CTOImg from "../assets/cto.jpg";

const AboutUs: React.FC = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  return (
    <div className="about-us">
      {/* Hero Section */}
      <div className="about-hero">
        <h1 data-aos="fade-up">About BBArive</h1>
        <p data-aos="fade-up" data-aos-delay="200">
          Revolutionizing the way people travel
        </p>
      </div>

      {/* Mission Section */}
      <div className="about-section">
        <div className="container">
          <div className="mission-content" data-aos="fade-right">
            <h2>Our Mission</h2>
            <p>
              At BBArive, we're on a mission to transform urban mobility. We
              believe in creating a world where transportation is accessible,
              sustainable, and enjoyable for everyone.
            </p>
          </div>
        </div>
      </div>

      {/* Stats Section */}
      <div className="stats-section">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-item" data-aos="zoom-in" data-aos-delay="0">
              <h3>1M+</h3>
              <p>Happy Riders</p>
            </div>
            <div className="stat-item" data-aos="zoom-in" data-aos-delay="200">
              <h3>500K+</h3>
              <p>Completed Rides</p>
            </div>
            <div className="stat-item" data-aos="zoom-in" data-aos-delay="400">
              <h3>50+</h3>
              <p>Cities</p>
            </div>
          </div>
        </div>
      </div>

      {/* Values Section */}
      <div className="values-section">
        <div className="container">
          <h2 data-aos="fade-up">Our Values</h2>
          <div className="values-grid">
            <div className="value-item" data-aos="fade-up" data-aos-delay="0">
              <FaRocket className="value-icon" />
              <h3>Innovation</h3>
              <p>Constantly evolving and improving our services</p>
            </div>
            <div className="value-item" data-aos="fade-up" data-aos-delay="200">
              <FaUsers className="value-icon" />
              <h3>Community</h3>
              <p>Building connections through shared journeys</p>
            </div>
            <div className="value-item" data-aos="fade-up" data-aos-delay="400">
              <FaCar className="value-icon" />
              <h3>Safety</h3>
              <p>Your security is our top priority</p>
            </div>
            <div className="value-item" data-aos="fade-up" data-aos-delay="600">
              <FaLeaf className="value-icon" />
              <h3>Sustainability</h3>
              <p>Committed to a greener future</p>
            </div>
          </div>
        </div>
      </div>

      {/* Team Section */}
      <div className="team-section">
        <div className="container">
          <h2 data-aos="fade-up">Our Leadership</h2>
          <div className="team-grid">
            <div className="team-member" data-aos="fade-up" data-aos-delay="0">
              <div
                className="member-image"
                style={{ backgroundImage: `url(${CEOImg})` }}
              ></div>
              <h3>Aakash Patel</h3>
              <p>Founder</p>
            </div>
            <div
              className="team-member"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              <div
                className="member-image"
                style={{ backgroundImage: `url(${CTOImg})` }}
              ></div>
              <h3>Azee</h3>
              <p>Chief Technology Officer & Founder</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
